var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.662,
    height: 35.144,
    viewBox: "0 0 82.662 35.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#9b0405;stroke:#9b0405}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1159633",
    "data-name": 1159633,
    transform: "translate(47.846 .239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    d: "M31.673 57.274a.855.855 0 0 0-.855.855v7.588a2.567 2.567 0 0 1-2.564 2.564h-71.326a2.567 2.567 0 0 1-2.564-2.564V43.445a2.567 2.567 0 0 1 2.564-2.564h54.934a.855.855 0 1 0 0-1.709h-54.934a4.278 4.278 0 0 0-4.273 4.273v22.272a4.278 4.278 0 0 0 4.273 4.273h71.326a4.278 4.278 0 0 0 4.273-4.273v-7.588a.855.855 0 0 0-.855-.855zm0 0",
    className: "cls-1",
    "data-name": "Path 1004",
    transform: "translate(0 -35.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    d: "M131.133 1.387a3.846 3.846 0 0 0-5.439 0l-15.248 15.248a.854.854 0 0 0-.219.376l-2.005 7.239a.854.854 0 0 0 1.052 1.052l7.239-2.005a.854.854 0 0 0 .376-.219l15.246-15.249a3.85 3.85 0 0 0 0-5.439zm-18.825 15.8l12.479-12.476 4.025 4.025-12.48 12.479zm-.8 1.613l3.215 3.216-4.448 1.232zm19.419-12.179l-.906.906L126 3.5l.9-.9a2.136 2.136 0 0 1 3.021 0l1 1a2.14 2.14 0 0 1 .006 3.021zm0 0",
    className: "cls-1",
    "data-name": "Path 1005",
    transform: "translate(-98.944)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.0aae342119dcf0b55b9633531a477fbb.svg";
export { ForwardRef as ReactComponent };